import React from 'react';
import { styled } from "../../../stitches.config"
import Link from "../../../components/Link";

import background from "./assets/header-background.jpg"
import backgroundMobile from "./assets/header-background-mobile.jpg"
import logo from "./assets/header-logo.svg"
import dots from "./assets/dots.svg"

import { ReactComponent as Text } from "./assets/header-text.svg?react"
import { ReactComponent as Button } from "./assets/header-btn.svg?react"


interface AtavistTestingHeaderProps {
    link: string;
}

const AtavistTestingHeader: React.FC<AtavistTestingHeaderProps> = ({
    link
}) => {
    return (
        <StyledAtavistTestingHeader>
            <Text className="text-svg" />
            <Logo></Logo>
            <Dots></Dots>
            <Link to={link}>
                <Button className="btn-svg" />
            </Link>
        </StyledAtavistTestingHeader>
    );
};


const StyledAtavistTestingHeader = styled('div', {
    fontFamily: "$charis",
    fontWeight: "700",
    backgroundImage: `url("${backgroundMobile}")`,
    height: "500px",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    position: "relative",
    marginBottom: "46px",
    "@bp3": {
        height: "660px",
        backgroundImage: `url("${background}")`,
    },
    "@bp4": {
        marginBottom: "60px",
    },
    "@bp5": {
        height: "720px",
    },
    // svg
    ".text-svg": {
        width: "320px",
        position: "absolute",
        left: "calc(50% - 160px)",
        top: "100px",
        "@media(min-width: 480px)": {
            top: "90px",
            width: "470px",
            left: "calc(50% - 235px)",
        },
        "@bp3": {
            left: "60px",
            top: "40px",
            width: "540px",
        },
    },
    ".btn-svg": {
        height: "48px",
        width: "300px",
        position: "absolute",
        left: "calc(50% - 150px)",
        bottom: "40px",
        cursor: "pointer",
        "@bp3": {
            height: "64px",
            width: "400px",
            left: "calc(50% - 200px)",
        },
        "&:hover": {
            ".cls-02": {
                transition: "0.3s",
                fill: "#2dcdcc",
            }
        }
    }
})

const Logo = styled('div', {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url("${logo}")`,
    height: "100px",
    width: "68px",
    position: "absolute",
    right: "40px",
    top: "15px",
    "@bp3": {
        right: "80px",
        top: "40px",
        height: "150px",
        width: "102px",
    },
    "@bp5": {
        right: "200px",
    }
})

const Dots = styled('div', {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url("${dots}")`,
    height: "100px",
    width: "44px",
    position: "absolute",
    left: "calc(32%)",
    top: "250px",
    "@bp3": {
        height: "200px",
        width: "88px",
        left: "calc(37% - 10px)",
        top: "300px",
    },
})


export default AtavistTestingHeader